exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collect-component{min-height:100vh;padding-bottom:50px;height:auto;color:#666}.collect-component .albums{font-size:16px;padding:10px 15px 0}.collect-component .desc{padding:0 20px;color:#0a0a0a;font-weight:500;font-size:14px;line-height:18px;margin-top:10px}.collect-component .desc div{font-size:12px;padding-top:5px}.collect-component .tag{padding-top:10px}.collect-component .tip{font-size:12px;color:#0a0a0a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Collect.scss
// module id = 631
// module chunks = 0